import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const DocumentTypeContent = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  fontSize: '1.25rem',
  fontWeight: 'bold',
  marginTop: '10px'
})